export default __webpack_public_path__ + "static/project-slide-4-768-700-3c201d3913e5bef8ef13aa27123f8d87.jpg";